

export default function(to, from) {
      if (to.hash) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({ selector: to.hash });
          }, 300);
        });
      }
      return { x: 0, y: 0 };
    }
